import React, { Component } from "react"
import PropTypes from 'prop-types'
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import { withRouter, Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import  { Redirect,useHistory } from 'react-router-dom'

// users
import user1 from "../../../assets/images/users/avatar-unisex.jpg"

class ProfileMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      menu: false,
      ok:"",
      name: "",
      user:JSON.parse(sessionStorage.getItem("authAshia"))?.profile,
      
    }
    this.toggle = this.toggle.bind(this)
  }

  toggle() {
    this.setState(prevState => ({
      menu: !prevState.menu,
    }))
  }
logout=()=>{
  
  sessionStorage.removeItem("authAshia")
  sessionStorage.removeItem("profileAuthAshia")

}
  componentDidMount() {
    if (sessionStorage.getItem("authAshia")) {
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const obj = JSON.parse(sessionStorage.getItem("authAshia"))
        this.setState({ name: obj.nom+" "+obj.prenom })
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        const obj = JSON.parse(sessionStorage.getItem("authAshia"))
        this.setState({ name: obj.nom+" "+obj.prenom })

      }
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.state.ok}
        <Dropdown
          isOpen={this.state.menu}
          toggle={this.toggle}
          className="d-inline-block"
        >
          <DropdownToggle
            className="btn header-item waves-effect"
            id="page-header-user-dropdown"
            tag="button"
          >
            <img
              className="rounded-circle header-profile-user"
              src={user1}
              alt="Header Avatar"
            />{" "}
            <span className="d-none d-xl-inline-block ms-1">
              {this.state.name}
            </span>
             {!this.state.user?
                <span onClick={e=>this.setState({ok:<Redirect to='/login'  />})} >{this.props.t("Se connecter")}</span>:
                <i className="mdi mdi-chevron-down d-none d-xl-inline-block"/>
             }
          </DropdownToggle>
          { 
           this.state.user?
            <DropdownMenu>

                <Link to="/profile" className="dropdown-item" >
                  <i className="bx bx-user font-size-16 align-middle me-1 "/>
                  <span>{this.props.t("Mon compte")}</span>
                </Link>

                <div className="dropdown-divider"/>
                
                <Link to="/" className="dropdown-item" onClick={this.logout}>
                  <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger"/>
                  <span>{this.props.t("Déconnexion")}</span>
                </Link>
              
            
            </DropdownMenu>:null
        }
        </Dropdown>
      </React.Fragment>
    )
  }
}

ProfileMenu.propTypes = {
  t: PropTypes.any
}

export default withRouter(withTranslation()(ProfileMenu))
